import {useEffect} from 'react'
import {useNavigate, useSearchParams, useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import getEventIdxFromUrl from 'shared/lib/getEventIdxFromUrl'

const usePostPaymentConfirm = () => {
	const navigate = useNavigate()
	const {type} = useParams()
	const [searchParams] = useSearchParams()
	const paymentKey = searchParams.get('paymentKey')
	const orderId = searchParams.get('orderId')
	const amount = searchParams.get('amount')

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		if (type === 'exam') {
			const examIdx = searchParams.get('examIdx')
			fetchRequest('POST', `/tryout/${examIdx}`, {
				paymentKey,
				orderId,
				amount,
			})
		} else if (type === 'real') {
			const examIdx = searchParams.get('examIdx')
			fetchRequest('POST', `/tryout/payment/${examIdx}/practical`, {
				paymentKey,
				orderId,
				amount,
			})
		} else if (type === 'event') {
			const eventIdx = getEventIdxFromUrl()
			fetchRequest('POST', `/event/${eventIdx}/tryout/register`, {
				paymentKey,
				orderId,
				amount,
			})
		} else if (type === 'premium') {
			fetchRequest('POST', `/account/premium`, {
				paymentKey,
				orderId,
				amount,
			})
		} else {
			setAlert('존재하지 않는 결제 품목 입니다.\n다시 시도해 주세요.')
			navigate('/')
		}
	}, [])

	return [fetchResult]
}

export default usePostPaymentConfirm
